<!-- src/app/components/qr-scanner/qr-scanner.component.html -->
<div class="qr-scanner-wrapper">
    <div class="qr-box">
      <div class="qr-placeholder">
        <svg width="200" height="200" viewBox="0 0 200 200">
          <rect x="10" y="10" width="180" height="180" fill="none" stroke="#3a82f6" stroke-width="4" />
          <rect x="30" y="30" width="140" height="140" fill="none" stroke="#3a82f6" stroke-width="4" />
          <rect x="50" y="50" width="100" height="100" fill="none" stroke="#3a82f6" stroke-width="4" />
          <rect x="70" y="70" width="60" height="60" fill="none" stroke="#3a82f6" stroke-width="4" />
        </svg>
      </div>
      <div class="scanner-animation"></div>
    </div>
    
    <h3 class="mt-4">Scan QR Code</h3>
    <p>Position the QR code within the frame to scan</p>
    
    <!-- For demo purposes, add a button to simulate scanning -->
    <button class="btn btn-primary btn-lg mt-3" (click)="scanQrCode()">
      Simulate QR Scan
    </button>
  </div>